/**
 * Zendure device action preparations.
 * Duplicated from Scenes for Flow independence.
 */

import type { DeviceActionContext, PreparedDeviceAction } from '../types';

export const prepareZendureAction = (context: DeviceActionContext): PreparedDeviceAction | null => {
	const { actions, hexToDecimal } = context;
	const action: PreparedDeviceAction = { _gui_purpose: 'action' };

	const output_limit = actions.find((el) => el.name === 'outputLimit');
	if (output_limit) {
		action.r = 'dev:' + hexToDecimal + ':outputLimit';
		action.set = actions[0].value;
		return action;
	}
	return null;
};
